'use strict';

import angular from 'angular';

import modalDirective from 'brg/rest/buttons/modal';
import resolveUsers from 'utils/resolve/users';

import addTemplate from './add.html';

const MODULE_NAME = 'daupler.entities.loveland.afterHoursLeader';

var app = angular.module(MODULE_NAME, [
	'ui.mask',
	'brg.components.inputs',
]);

app.directive('addLovelandAfterHoursLeader', modalDirective({
	template: addTemplate,
	resolve: {
		users: resolveUsers,
	},
	controller: addController,
}));

export default MODULE_NAME;


function addController($scope) {
	'ngInject';

	$scope.updateLeader = function(response) {
		var data = response.data;
		angular.merge($scope.$resolve.$context.currentLeader, {
			phone_number: data.phone_number,
			user: data.user,
			created_time: new Date(),
		});
	}
}
